import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'
import ImageWithPlaceholderFallback from 'components/ui/ImageWithPlaceholderFallback/ImageWithPlaceholderFallback'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'
import ProductLabels from 'components/product/ProductLabels/ProductLabels'
import Loader from 'components/loaders/Loader/Loader'

import s from './ProductImage.scss'


const ProductImage = (props) => {
  const { className, src, w, mW, link, withMicrodata, labels, upchargePrice, toOLD, onClick } = props

  const isLink  = link || toOLD
  const node    = isLink ? Link : 'div'

  const nodeProps = {
    className: cx(s.container, className),
    to: link,
    onClick,
  }

  if (toOLD) { // fix propTypes warning in console (productPage)
    nodeProps.toOLD = toOLD
  }

  return React.createElement(
    node,
    nodeProps,
    Boolean(labels) && (
      <ProductLabels className={s.labels} items={labels} />
    ),
    <Fragment>
      <Loader className={s.loader} />
      <ImageWithPlaceholderFallback
        key={src}
        className={s.image}
        src={src}
        w={w}
        mW={mW}
        alt="product"
        {...(withMicrodata && { itemProp: 'image' })}
      />
    </Fragment>,
    Boolean(upchargePrice) && (
      <UpchargePrice className={s.upchargePrice} price={upchargePrice} large />
    ),
  )
}

ProductImage.propTypes = {
  src: PropTypes.string,
  link: PropTypes.string,
  labels: PropTypes.array,
  withMicrodata: PropTypes.bool,
  upchargePrice: PropTypes.number,
}


export default ProductImage
